import { Injectable } from '@angular/core';
import {WebSocketSubject} from "rxjs/internal/observable/dom/WebSocketSubject";
import {webSocket} from "rxjs/webSocket";
import {environment} from "../../../environments/environment";
import {getLocalStorageKey} from "@shared/utils/utils";
const WS_ENDPOINT = environment.websocketEndpoint;

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {

  private socket$: WebSocketSubject<any> | undefined;
  constructor() { }

  public async connect() {
    if (!this.socket$ || this.socket$.closed) {
      this.socket$ = await this.getNewWebSocket();
    }
    return this.socket$;
  }

  private async getNewWebSocket() {
    return webSocket({
      url: WS_ENDPOINT + '?token=' + getLocalStorageKey('accessToken').toString() ?? '',
      closeObserver: {
        next: () => {
          console.log('[WebSocketService]: Connection Closed');
          this.socket$ = undefined;
          this.connect();
        }
      }
    })
  }

  public async sendMessage(msg: any){
    this.socket$!.next(msg);
  }

  public close(){
    this.socket$!.complete();
    this.socket$ = undefined;
  }
}
